import {
  CLEAR_IMPORT_FILES,
  SET_MAPPING_FILE,
  SET_IMPORT,
  SET_IMPORT_FILES,
  SET_IMPORT_STATUS_TYPE
} from '../actions/importer';

const defaultState = {
  import: {},
  currentFile: {},
  files: []
};

export default function(state = defaultState, action) {
  switch (action.type) {
  case CLEAR_IMPORT_FILES:
    return { ...state, files: [], currentFile: {} };
  case SET_IMPORT:
    return { ...state, import: action.importer };
  case SET_MAPPING_FILE:
    return { ...state, currentFile: action.currentFile };
  case SET_IMPORT_FILES:
    return { ...state, files: action.files };
  case SET_IMPORT_STATUS_TYPE: {
    const importer = { ...state.import, statusType: action.statusType };
    return { ...state, import: importer };
  }
  default:
    return state;
  }
}
